/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard standardized components
import CreateButton from "components/standardized-components/CreateButton";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createActionForModuleManagement,
  deleteAsset,
  getActionsForMaping,
  getActionsForModuleManagement,
  getAssetTypes,
  getBins,
  getMappedBinsByRfid,
  getModulesForModuleManagement,
  getSubModulesByRoleId,
  getUnmappedBins,
  getUnmappedPallets,
  getsubModuleByModule,
  mapActionForModuleManagement,
  mapAsset,
  updateActionForModuleManagement,
  updateAsset,
  uploadAssetMaster,
} from "../../../store";

// React-Select component and styling
import Select from "react-select";
import "../../../index.css";

// Cookies
import { CircularProgress } from "@mui/material";
import EditButton from "components/standardized-components/EditButton";
import { addMinutes, format } from "date-fns";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};
const styleForPicklistViewModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",
  width: { xs: 350, lg: 1000 },
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Action = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getActionsForModuleManagement,
  getAssetsReducer,
  moduleBySubmoduleReducer,
  actionsForModuleReducer,
  createActionForModuleManagement,
  getAssetTypes,
  assetTypes,
  deleteAsset,
  actionForMappingReducer,
  updateAsset,
  mapActionForModuleManagement,
  updateActionForModuleManagement,
  modulesReducerForManagement,
  getsubModuleByModule,
  getUnmappedBins,
  getUnmappedPallets,
  getUnmappedBinsReducer,
  getModulesForModuleManagement,
  getUnmappedPalletsReducer,
  mapAsset,
  getMappedBinsByRifdReducer,
  getActionsForMaping,
  uploadAssetMaster,
  getMappedBinsByRfid,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;

  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  useEffect(() => {
    getModulesForModuleManagement(jwtToken);
  }, []);
  useEffect(() => {
    getActionsForMaping(jwtToken);
  }, []);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let actionParentModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "1b27aa80-813b-4112-9af3-e56e85caf672",
  );
  let createAccess = actionParentModule
    ? actionParentModule.actionId.includes(
        "79bc9d88-21f3-4af2-8d11-37a950db8658",
      )
    : null;
  let viewAccess = actionParentModule
    ? actionParentModule.actionId.includes(
        "84e8c86d-cd38-49dc-9dd1-abecfe9aaa0b",
      )
    : null;
  let editAccess = actionParentModule
    ? actionParentModule.actionId.includes(
        "b8fc089c-60fe-40e5-87d2-d0677372b2ef",
      )
    : null;
  let deleteAccess = actionParentModule
    ? actionParentModule.actionId.includes(
        "06a3d28c-8071-4c08-bc3b-d7419cc63aec",
      )
    : null;
  let mapAccess = actionParentModule
    ? actionParentModule.actionId.includes(
        "0aebee48-0ab9-43b5-a613-802411c611ac",
      )
    : null;

  useEffect(() => {
    getActionsForModuleManagement(jwtToken);
  }, []);

  const [state, setState] = useState({
    columns: [
      { Header: " Action Name", accessor: "actionName" },

      { Header: " SubModule Name", accessor: "subModuleName" },
      //   { Header: "Asset Type", accessor: "assetType" },
      //   { Header: "Printer Ip ", accessor: "printerIp" },
      //   { Header: "Printer Port", accessor: "printerPort" },
      //   { Header: "Created Date", accessor: "createdDate" },
      {
        Header: "action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [errorMsgForMapAsset, setErrorMsgForMapAsset] = useState("");

  const [isErrorCreateNewAsset, setIsErrorCreateNewAsset] = useState(false);
  const [isSuccessCreateNewAsset, setIsSuccessCreateNewAsset] = useState(false);

  useEffect(() => {
    if (isErrorCreateNewAsset) {
      setTimeout(() => {
        setIsErrorCreateNewAsset(false);
      }, 3000);
    }
  }, [isErrorCreateNewAsset]);

  useEffect(() => {
    if (isSuccessCreateNewAsset) {
      setTimeout(() => {
        setIsSuccessCreateNewAsset(false);
      }, 3000);
    }
  }, [isSuccessCreateNewAsset]);

  const [assetTypeSelected, setAssetTypeSelected] = useState("");
  const [subModuleSelected, setSubModuleSelected] = useState("");
  const [actionForMappingSelected, setActionForMappingSelected] = useState("");
  const [assetTypeOptions, setAssetTypeOptions] = useState([]);
  const [actionForMapping, setactionForMapping] = useState([]);

  useEffect(() => {
    let tempAssetTypeOptions = [];
    let data = modulesReducerForManagement.modules.data
      ? modulesReducerForManagement.modules.data
      : [];
    data.map((asset) => {
      tempAssetTypeOptions.push({
        label: asset.moduleName,
        value: asset.moduleId,
      });
    });

    setAssetTypeOptions(tempAssetTypeOptions);
  }, [modulesReducerForManagement]);

  useEffect(() => {
    let tempAssetTypeOptions = [];
    let data = actionForMappingReducer.actions.data
      ? actionForMappingReducer.actions.data
      : [];
    data.map((asset) => {
      tempAssetTypeOptions.push({
        label: asset.actionName,
        value: asset.actionId,
      });
    });

    setactionForMapping(tempAssetTypeOptions);
  }, [actionForMappingReducer]);

  const [subModules, setSubModules] = useState([]);

  useEffect(() => {
    let tempAssetTypeOptions = [];
    let data = moduleBySubmoduleReducer.modules.data
      ? moduleBySubmoduleReducer.modules.data
      : [];
    data.map((asset) => {
      tempAssetTypeOptions.push({
        label: asset.subModuleName,
        value: asset.subModuleId,
      });
    });

    setSubModules(tempAssetTypeOptions);
  }, [moduleBySubmoduleReducer]);
  useEffect(() => {
    getsubModuleByModule(assetTypeSelected?.value, jwtToken);
  }, [assetTypeSelected]);

  const [openBinViewModal, setOpenBinViewModal] = useState(false);

  const handleOpenViewBinModal = (assets) => {
    setOpenBinViewModal(true);
  };

  const handleCloseViewBinModal = () => {
    setOpenBinViewModal(false);
  };

  const [suidTable, setSuidTable] = useState({
    columns: [
      { Header: "Bin/Pallet Code", accessor: "binCode", align: "left" },
      { Header: "Bin/Pallet Name", accessor: "binName" },

      { Header: "Created Date", accessor: "createdDate", align: "left" },
      // { Header: "location Code", accessor: "locationCode", align: "left" },
    ],
    rows: [],
  });

  const [loading2, setLoading2] = useState(false);

  const { columns: binColumns, rows: binRows } = suidTable;
  useEffect(() => {
    let tempGRN = [];
    let data = getMappedBinsByRifdReducer.mappedBins.data
      ? getMappedBinsByRifdReducer.mappedBins.data
      : [];
    setLoading2(getMappedBinsByRifdReducer.loading);
    data.map((singleSuid) => {
      const formatDate = new Date(singleSuid.cd);

      const singleUser = {
        binCode: singleSuid.code,
        binName: singleSuid.name,
        lotSerialNo: `${singleSuid.lotNumber ? singleSuid.lotNumber : "NA"} / ${
          singleSuid.serialNumber ? singleSuid.serialNumber : "NA"
        }`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "do MMMM yyyy",
        ),
        locationCode: singleSuid.locationCode,
      };
      tempGRN.push(singleUser);
    });
    setSuidTable({ ...suidTable, rows: tempGRN });
  }, [getMappedBinsByRifdReducer]);
  const [loading, setLoading] = useState(true);
  const [rfid, setRfid] = useState("");
  useEffect(() => {
    getMappedBinsByRfid(rfid, jwtToken);
  }, [rfid]);

  useEffect(() => {
    let tempAsset = [];
    let data = actionsForModuleReducer.actions.data
      ? actionsForModuleReducer.actions.data
      : [];
    setLoading(actionsForModuleReducer.loading);
    data.map((assets) => {
      const formatDate = new Date(assets.cd);
      const assetsObject = {
        actionName: assets.actionName,
        subModuleName: assets.subModuleName,
        //         assetType: assets.assetTypeCode,
        //         printerIp: assets.printerIp,
        //         printerPort: assets.printerPort,
        //         createdDate: format(
        //           addMinutes(formatDate, formatDate.getTimezoneOffset()),
        //           "do MMMM yyyy"
        //         ),

        //         isEditable: assets.isEditable,
        action: (
          <div>
            {editAccess && (
              <EditButton
                tooltip="Edit"
                disabled={assets.isEditable === 0}
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateAssetModal(assets)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </div>
        ),
      };
      tempAsset.push(assetsObject);
    });

    viewAccess && setState({ ...state, rows: tempAsset });
  }, [actionsForModuleReducer]);

  const handleAssetTypeChange = (selectedZone) => {
    setAssetTypeSelected(selectedZone);
  };

  const handleSubModuleChange = (selectedZone) => {
    setSubModuleSelected(selectedZone);
  };
  const handleActionForMappingChange = (selectedZone) => {
    setActionForMappingSelected(selectedZone);
  };

  let typeOptions = [
    {
      label: "Bin",
      value: "bin",
    },
    {
      label: "Pallet",
      value: "pallet",
    },
  ];

  const [masterOptions, setMasterTypeOptions] = useState([]);

  const [selectedType, setSelectedType] = useState("");

  const handleTypeChange = (selectedMaster) => {
    setSelectedType(selectedMaster);
    setSelectedMaster("");
  };

  useEffect(() => {
    let tempBinPalletOptions = [];
    let data;
    if (selectedType?.value == "bin") {
      data = getUnmappedBinsReducer.unBins.data
        ? getUnmappedBinsReducer.unBins.data
        : [];
    }

    if (selectedType?.value == "pallet") {
      data = getUnmappedPalletsReducer.unPallets.data
        ? getUnmappedPalletsReducer.unPallets.data
        : [];
    }
    data?.map((asset) => {
      tempBinPalletOptions.push({
        label: selectedType?.value == "bin" ? asset.binCode : asset.palletCode,
        value: selectedType?.value == "bin" ? asset.binId : asset.palletId,
      });
    });

    setMasterTypeOptions(tempBinPalletOptions);
  }, [assetTypes, selectedType]);

  const [selectedMaster, setSelectedMaster] = useState("");

  const handleMasterChange = (selectedMaster) => {
    setSelectedMaster(selectedMaster);
  };

  const [openCreateAssetModal, setOpenCreateAssetModal] = useState(false);

  const handleOpenCreateAssetModal = () => {
    getAssetTypes(jwtToken);
    setOpenCreateAssetModal(true);
    setAssetTypeSelected("");
  };

  const handleCloseCreateAssetModal = () => {
    formikForCreateAsset.setValues(initialValueForCreateAsset);
    formikForCreateAsset.setTouched({});
    formikForCreateAsset.setErrors({});
    setOpenCreateAssetModal(false);
    setAssetTypeSelected("");
    setSubModuleSelected("");
  };

  const initialValueForCreateAsset = {
    assetCode: "",
  };

  let isRequired = true;

  const validationSchema = Yup.object({
    // assetName: isRequired
    //   ? Yup.string().required("Enter the Asset Name")
    //   : Yup.string().notRequired(),
    assetCode: Yup.string().required("Enter the Name"),
  });

  const [buttonName, setButtonName] = useState("Create");
  const onSubmitForCreateAssetMaster = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    let payload = {
      actionName: values.assetCode,
    };
    let res = await createActionForModuleManagement(payload, jwtToken);
    if (res.status) {
      setIsSuccessCreateNewAsset(true);
      getActionsForModuleManagement(jwtToken);
      setAssetTypeSelected("");
      setSubModuleSelected("");
      setTimeout(() => {
        setButtonName("Create");
      }, 2250);

      resetForm();
    }
    if (!res.status) {
      setErrorMsgForCreate(res.data.data.msg);
      setIsErrorCreateNewAsset(true);
      setButtonName("Create ");
    }
  };

  const formikForCreateAsset = useFormik({
    initialValues: initialValueForCreateAsset,
    validationSchema: validationSchema,
    onSubmit: onSubmitForCreateAssetMaster,
  });

  const [openDeleteAssetModal, setOpenDeleteAssetModal] = useState(false);
  const [singleAssetDataForDelete, setSingleAssetDataForDelete] = useState({});

  const handleOpenDeleteAssetModal = (asset = {}) => {
    setSingleAssetDataForDelete(asset);
    setOpenDeleteAssetModal(true);
  };
  const handleCloseDeleteAssetModal = () => {
    setOpenDeleteAssetModal(false);
    setAssetTypeSelected("");
  };

  const [isErrorDeleteAsset, setIsErrorDeleteAsset] = useState(false);
  const [isSuccessDeleteAsset, setIsSuccessDeleteAsset] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAsset) {
      setTimeout(() => {
        setIsErrorDeleteAsset(false);
      }, 3000);
    }
  }, [isErrorDeleteAsset]);

  useEffect(() => {
    if (isSuccessDeleteAsset) {
      setTimeout(() => {
        setIsSuccessDeleteAsset(false);
      }, 3000);
    }
  }, [isSuccessDeleteAsset]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteAssetData = async () => {
    setDeleteButtonName("Please wait...");
    let assetId = singleAssetDataForDelete.assetId;

    let response = await deleteAsset(assetId, userId, jwtToken);

    if (response.status) {
      setIsSuccessDeleteAsset(true);
      // getAssets(jwtToken);

      setTimeout(() => {
        handleCloseDeleteAssetModal();
        setDeleteButtonName("Delete");
      }, 2250);
    }
    if (!response.status) {
      setErrorMsgForDelete(response.data.data.msg);
      setIsErrorDeleteAsset(true);
      setDeleteButtonName("Delete");
    }
  };

  const [openUpdateAssetModal, setOpenUpdateAssetModal] = useState(false);
  const [singleAssetDataForUpdate, setAssetDataForUpdate] = useState({});
  const handleOpenUpdateAssetModal = (Asset = {}) => {
    setAssetDataForUpdate(Asset);
    setOpenUpdateAssetModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateAssetModal = () => {
    setOpenUpdateAssetModal(false);
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    assetName: singleAssetDataForUpdate.actionName,
    printerIp: singleAssetDataForUpdate.printerIp,
    printerPort: singleAssetDataForUpdate.printerPort,
  };
  const validationSchemaForUpdate = Yup.object({
    assetName: Yup.string().required("Enter the name!"),
  });

  const [editButtonName, setEditButtonName] = useState("Submit");
  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      actionName: values.assetName,
      actionId: singleAssetDataForUpdate.actionId,
    };
    let res = await updateActionForModuleManagement(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getActionsForModuleManagement(jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res.data.data.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [openMapAssetModal, setOpenMapAssetModal] = useState(false);
  const [singleAssetDataForMapAsset, setSingleAssetDataForMapAsset] = useState(
    {},
  );

  const handleOpenMapAssetModal = (Asset = {}) => {
    setOpenMapAssetModal(true);
    setSingleAssetDataForMapAsset(Asset);
    setSelectedType("");
    setSelectedMaster("");
  };

  const handleCloseMapAssetModal = () => {
    setOpenMapAssetModal(false);
    setAssetTypeSelected("");
    setSubModuleSelected("");
    setActionForMappingSelected("");
  };

  const [isErrorForMapAsset, setIsErrorForMapAsset] = useState(false);
  const [isSuccessForMapAsset, setIsSuccessForMapAsset] = useState(false);

  useEffect(() => {
    if (isErrorForMapAsset) {
      setTimeout(() => {
        setIsErrorForMapAsset(false);
      }, 3000);
    }
  }, [isErrorForMapAsset]);

  useEffect(() => {
    if (isSuccessForMapAsset) {
      setTimeout(() => {
        setIsSuccessForMapAsset(false);
      }, 3000);
    }
  }, [isSuccessForMapAsset]);

  const initialValueForMapAsset = {
    assetType: "",
  };

  const validationSchemaForMapAsset = Yup.object({});

  const [mapButtonName, setMapButtonName] = useState("Submit");

  const onSubmitForForMapAsset = async (values, { resetForm }) => {
    setMapButtonName("Please wait...");
    let payload = {
      actionId: actionForMappingSelected?.value,
      subModuleId: subModuleSelected?.value,
    };
    let res = await mapActionForModuleManagement(payload, jwtToken);

    if (res.status) {
      setIsSuccessForMapAsset(true);
      getActionsForModuleManagement(jwtToken);
      setAssetTypeSelected("");
      setSubModuleSelected("");
      setActionForMappingSelected("");
      setTimeout(() => {
        setMapButtonName("Submit");
      }, 2250);
      resetForm();
    }
    if (!res.status) {
      setErrorMsgForMapAsset(res.data.data.msg);
      setIsErrorForMapAsset(true);
      setMapButtonName("Submit");
    }
  };

  const formikForMapAsset = useFormik({
    initialValues: initialValueForMapAsset,
    validationSchema: validationSchemaForMapAsset,
    onSubmit: onSubmitForForMapAsset,
  });

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = () =>
    toast.error("Please check the data format", {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("userId", userId);
    data.append("asset", uploadCsvData);

    let res = await uploadAssetMaster(data, jwtToken);

    if (res.status) {
      // getAssets(jwtToken);
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      DataUploadFailureNotification();
    }
  };

  const headers = [
    {
      label: "assetCode",
      key: "assetCode",
    },
    {
      label: "assetName",
      key: "assetName",
    },
    { label: "assetTypeCode", key: "assetTypeCode" },
    { label: "printerIp", key: "printerIp" },
    { label: "printerPort", key: "printerPort" },
  ];

  const csvLink = {
    filename: "Assets List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Asset Template.csv",
    headers: headers,
    data: [],
  };

  return (
    <div>
      {/* <DashboardLayout>
        <DashboardNavbar /> */}

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <Card> */}
            {/* {createAssetAccess && ( */}
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              //   p={3}
              // mb={3}
            >
              <MDBox color="text" px={2} ml={-2} mb={1}>
                {createAccess && (
                  <CreateButton
                    // tooltip="Create Asset"
                    color="info"
                    variant="contained"
                    type="button"
                    onClick={handleOpenCreateAssetModal}
                    style={{ marginLeft: "10px" }}
                    iconOnly
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                )}
                {mapAccess && (
                  <MDButton
                    // tooltip="Create Asset"
                    color="success"
                    variant="contained"
                    type="button"
                    onClick={handleOpenMapAssetModal}
                    style={{ marginLeft: "10px" }}
                    iconOnly
                  >
                    <Icon>map</Icon>
                  </MDButton>
                )}
                {/* )} */}

                {/* <CSVLink {...csvLink2}>
                      <DownloadButton
                        tooltip="Download Template"
                        style={{ marginRight: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadButton>
                    </CSVLink>

                    {uploadAccess && (
                      <UploadButton
                        tooltip="Upload Asset Master"
                        style={{ marginRight: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="info"
                        iconOnly
                        onClick={uploadCsvFilterHandler}
                      >
                        <Icon>upload</Icon>
                      </UploadButton>
                    )}

                    {downloadAccess && (
                      <CSVLink {...csvLink}>
                        <DownloadDataButton
                          tooltip="Download Asset List"
                          style={{ marginRight: "1rem" }}
                          type="button"
                          variant="outlined"
                          color="success"
                          iconOnly
                        >
                          <Icon>download</Icon>
                        </DownloadDataButton>
                      </CSVLink>
                    )} */}
              </MDBox>
            </MDBox>
            {uploadCsvFilter && (
              <div>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      // marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />

                  <MDButton
                    disabled={
                      !uploadCsvData.name || uploadCsvData.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "0" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}

            <MDBox mt={0}>
              {/* {!loading ?
                   ( */}
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                showTotalEntries={true}
                noEndBorder
                options={{ draggable: false }}
                hideColumns={["", "printerIp", "printerPort"]}
              />
              {/* ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                        marginBottom: "100px",
                      }}
                    >
                      <CircularProgress color="info" />
                    </div>
                  )} */}
            </MDBox>
            <Modal
              open={openCreateAssetModal}
              onClose={handleCloseCreateAssetModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Create
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={handleCloseCreateAssetModal}
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginLeft: "-55px",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForCreateAsset.handleSubmit}
                  >
                    <MDBox>
                      {/* <MDBox mb={2}>
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Select the Module
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Select the Type..."
                          name="assetType"
                          value={assetTypeSelected}
                          options={assetTypeOptions}
                          onChange={(selectedOption) => {
                            handleAssetTypeChange(selectedOption);
                            formikForCreateAsset.setFieldValue(
                              "assetType",
                              selectedOption
                            );
                          }}
                        />
                        {formikForCreateAsset.errors.assetType && (
                          <TextError
                            msg={formikForCreateAsset.errors.assetType}
                          />
                        )}
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Select SubModule
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Select the Type..."
                          name="assetType"
                          value={subModuleSelected}
                          options={subModules}
                          onChange={(selectedOption) => {
                            handleSubModuleChange(selectedOption);
                            formikForCreateAsset.setFieldValue(
                              "assetType",
                              selectedOption
                            );
                          }}
                        />
                        {formikForCreateAsset.errors.assetType && (
                          <TextError
                            msg={formikForCreateAsset.errors.assetType}
                          />
                        )}
                      </MDBox> */}
                      <MDBox mb={2}>
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Name
                        </MDTypography>

                        <MDInput
                          type="text"
                          name="assetCode"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForCreateAsset.handleBlur}
                          onChange={formikForCreateAsset.handleChange}
                          value={formikForCreateAsset.values.assetCode}
                          error={
                            formikForCreateAsset.touched.assetCode &&
                            Boolean(formikForCreateAsset.errors.assetCode)
                          }
                        />

                        {/* Error message display */}
                        {formikForCreateAsset.touched.assetCode &&
                          formikForCreateAsset.errors.assetCode && (
                            <TextError
                              msg={formikForCreateAsset.errors.assetCode}
                            />
                          )}
                      </MDBox>

                      {/* <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Asset Description (Optional)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="assetName"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForCreateAsset.handleBlur}
                              onChange={formikForCreateAsset.handleChange}
                              value={formikForCreateAsset.values.assetName}
                              error={
                                formikForCreateAsset.touched.assetName &&
                                formikForCreateAsset.errors.assetName &&
                                true
                              }
                            />
                            {formikForCreateAsset.errors.assetName && (
                              <TextError
                                msg={formikForCreateAsset.errors.assetName}
                              />
                            )}
                          </MDBox> */}
                      {assetTypeSelected?.value === 5 && (
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            IP
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="ip"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForCreateAsset.handleBlur}
                            onChange={formikForCreateAsset.handleChange}
                            value={formikForCreateAsset.values.ip}
                            error={
                              formikForCreateAsset.touched.ip &&
                              formikForCreateAsset.errors.ip &&
                              true
                            }
                          />
                          {formikForCreateAsset.errors.ip && (
                            <TextError msg={formikForCreateAsset.errors.ip} />
                          )}
                        </MDBox>
                      )}
                      {assetTypeSelected?.value === 5 && (
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Port
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="port"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForCreateAsset.handleBlur}
                            onChange={formikForCreateAsset.handleChange}
                            value={formikForCreateAsset.values.port}
                            error={
                              formikForCreateAsset.touched.port &&
                              formikForCreateAsset.errors.port &&
                              true
                            }
                          />
                          {formikForCreateAsset.errors.port && (
                            <TextError msg={formikForCreateAsset.errors.port} />
                          )}
                        </MDBox>
                      )}
                      <MDBox mt={2}>
                        <Collapse in={isSuccessCreateNewAsset}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessCreateNewAsset(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created successfully!
                          </Alert>
                        </Collapse>
                        <Collapse in={isErrorCreateNewAsset}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorCreateNewAsset(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {/* Could not create the Asset! */}
                            {errorMsgForCreate}
                          </Alert>
                        </Collapse>
                      </MDBox>

                      <div className="mt-3">
                        <MDButton
                          type="submit"
                          variant="gradient"
                          color="info"
                          fullWidth
                          disabled={
                            !formikForCreateAsset.isValid ||
                            (assetTypeSelected?.value === 5 &&
                              formikForCreateAsset.values.ip == "") ||
                            (assetTypeSelected?.value === 5 &&
                              formikForCreateAsset.values.port == "") ||
                            buttonName === "Please wait..."
                          }
                        >
                          {buttonName}
                        </MDButton>
                      </div>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openMapAssetModal}
              onClose={handleCloseMapAssetModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Map
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseMapAssetModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForMapAsset.handleSubmit}
                  >
                    {/* <MDBox mb={1}>
                      <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                        {" "}
                        Select Type
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={130}
                        placeholder="Choose one..."
                        name="type"
                        value={selectedType}
                        options={typeOptions}
                        onChange={(selectedOption) => {
                          handleTypeChange(selectedOption);

                          formikForMapAsset.setFieldValue(
                            "type",
                            selectedOption
                          );
                        }}
                      />
                    </MDBox> */}

                    <MDBox mb={2}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Select the Module
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={130}
                        placeholder="Select the Type..."
                        name="assetType"
                        value={assetTypeSelected}
                        options={assetTypeOptions}
                        onChange={(selectedOption) => {
                          handleAssetTypeChange(selectedOption);
                          formikForMapAsset.setFieldValue(
                            "assetType",
                            selectedOption,
                          );
                        }}
                      />
                      {formikForMapAsset.errors.assetType && (
                        <TextError msg={formikForMapAsset.errors.assetType} />
                      )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Select SubModule
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={130}
                        placeholder="Select the Type..."
                        name="assetType"
                        value={subModuleSelected}
                        options={subModules}
                        onChange={(selectedOption) => {
                          handleSubModuleChange(selectedOption);
                          formikForMapAsset.setFieldValue(
                            "assetType",
                            selectedOption,
                          );
                        }}
                      />
                      {formikForMapAsset.errors.assetType && (
                        <TextError msg={formikForMapAsset.errors.assetType} />
                      )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Select Actions
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={90}
                        placeholder="Select Actions..."
                        name="assetType"
                        value={actionForMappingSelected}
                        options={actionForMapping}
                        onChange={(selectedOption) => {
                          handleActionForMappingChange(selectedOption);
                          formikForMapAsset.setFieldValue(
                            "assetType",
                            selectedOption,
                          );
                        }}
                      />
                      {formikForMapAsset.errors.assetType && (
                        <TextError msg={formikForMapAsset.errors.assetType} />
                      )}
                    </MDBox>
                    {selectedType && (
                      <MDBox mb={1}>
                        <MDTypography
                          variant="h6"
                          style={{ fontWeight: "500" }}
                        >
                          {selectedType?.label}
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="master"
                          value={selectedMaster}
                          options={masterOptions}
                          onChange={(selectedOption) => {
                            handleMasterChange(selectedOption);
                            // formikForMapAsset.setFieldValue(
                            //   "master",
                            //   selectedOption
                            // );
                          }}
                        />
                      </MDBox>
                    )}
                    <MDBox>
                      <Collapse in={isErrorForMapAsset}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForMapAsset(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForMapAsset}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForMapAsset}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForMapAsset(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Mapped successfully
                        </Alert>
                      </Collapse>
                    </MDBox>

                    <MDBox mt={3}>
                      <MDButton
                        color="success"
                        fullWidth
                        type="submit"
                        disabled={
                          !formikForMapAsset.isValid ||
                          mapButtonName === "Please wait..."
                        }
                      >
                        {mapButtonName}
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateAssetModal}
              onClose={handleCloseUpdateAssetModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseUpdateAssetModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography variant="h6">Action Name</MDTypography>
                      <MDInput
                        type="text"
                        name="assetName"
                        fullWidth
                        autoComplete="off"
                        onBlur={formikForUpdate.handleBlur}
                        onChange={formikForUpdate.handleChange}
                        value={formikForUpdate.values.assetName}
                        error={
                          formikForUpdate.touched.assetName &&
                          formikForUpdate.errors.assetName &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForUpdate.touched.assetName &&
                        formikForUpdate.errors.assetName && (
                          <TextError msg={formikForUpdate.errors.assetName} />
                        )}
                    </MDBox>
                    {singleAssetDataForUpdate?.assetTypeId === 5 && (
                      <MDBox mb={2}>
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          IP
                        </MDTypography>
                        <MDInput
                          type="text"
                          name="printerIp"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.printerIp}
                          error={
                            formikForUpdate.touched.printerIp &&
                            formikForUpdate.errors.printerIp &&
                            true
                          }
                        />
                        {formikForUpdate.errors.printerIp && (
                          <TextError msg={formikForUpdate.errors.printerIp} />
                        )}
                      </MDBox>
                    )}
                    {singleAssetDataForUpdate?.assetTypeId === 5 && (
                      <MDBox mb={2}>
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Port
                        </MDTypography>
                        <MDInput
                          type="number"
                          name="printerPort"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.printerPort}
                          error={
                            formikForUpdate.touched.printerPort &&
                            formikForUpdate.errors.printerPort &&
                            true
                          }
                        />
                        {formikForUpdate.errors.printerPort && (
                          <TextError msg={formikForUpdate.errors.printerPort} />
                        )}
                      </MDBox>
                    )}
                    <MDBox>
                      <Collapse in={isErrorForUpdate}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForUpdate}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForUpdate}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Updated successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="contained"
                        color="success"
                        fullWidth
                        type="submit"
                        disabled={
                          !formikForUpdate.isValid ||
                          editButtonName === "Please wait..."
                        }
                      >
                        {editButtonName}
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openDeleteAssetModal}
              onClose={handleCloseDeleteAssetModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2} display="flex">
                  <div>
                    <MDButton
                      style={{ width: "100%", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseDeleteAssetModal}
                    >
                      Cancel
                    </MDButton>
                  </div>
                  <div style={{ float: "right" }}>
                    <MDButton
                      style={{ width: "100%", marginLeft: "0.5rem" }}
                      color="error"
                      onClick={deleteAssetData}
                      disabled={deleteButtonName === "Please wait..."}
                    >
                      {deleteButtonName}
                    </MDButton>
                  </div>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessDeleteAsset}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessDeleteAsset(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Asset deleted successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorDeleteAsset}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorDeleteAsset(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMsgForDelete}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openBinViewModal}
              onClose={handleCloseViewBinModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForPicklistViewModal}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    {rfid}
                  </MDTypography>

                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                            marginBottom: "5px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseViewBinModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <MDBox>
                  {!loading2 ? (
                    <DataTable
                      table={{ columns: binColumns, rows: binRows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                        marginBottom: "100px",
                      }}
                    >
                      <CircularProgress color="info" />
                    </div>
                  )}
                </MDBox>
              </MDCard>
            </Modal>
            {/* </Card> */}
          </Grid>
        </Grid>
      </MDBox>
      <ToastContainer />
      {/* <Footer /> */}
      {/* </DashboardLayout> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getAssetsReducer: state.getAssetsReducer,
    getUnmappedBinsReducer: state.getUnmappedBinsReducer,
    getUnmappedPalletsReducer: state.getUnmappedPalletsReducer,
    assetTypes: state.getAssetTypesReducer,
    getMappedBinsByRifdReducer: state.getMappedBinsByRifdReducer,
    actionsForModuleReducer: state.actionsForModuleReducer,
    moduleBySubmoduleReducer: state.moduleBySubmoduleReducer,
    actionForMappingReducer: state.actionForMappingReducer,
    modulesReducerForManagement: state.modulesReducerForManagement,
    profileData: state.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getActionsForModuleManagement: (jwtToken) =>
      dispatch(getActionsForModuleManagement(jwtToken)),
    deleteAsset: (assetId, userId, jwtToken) =>
      dispatch(deleteAsset(assetId, userId, jwtToken)),
    createActionForModuleManagement: (payload, jwtToken) =>
      dispatch(createActionForModuleManagement(payload, jwtToken)),
    updateActionForModuleManagement: (payload, jwtToken) =>
      dispatch(updateActionForModuleManagement(payload, jwtToken)),
    mapActionForModuleManagement: (payload, jwtToken) =>
      dispatch(mapActionForModuleManagement(payload, jwtToken)),
    updateAsset: (payload, jwtToken) =>
      dispatch(updateAsset(payload, jwtToken)),
    mapAsset: (payload, type, jwtToken) =>
      dispatch(mapAsset(payload, type, jwtToken)),
    getAssetTypes: (jwtToken) => dispatch(getAssetTypes(jwtToken)),
    getModulesForModuleManagement: (jwtToken) =>
      dispatch(getModulesForModuleManagement(jwtToken)),
    getsubModuleByModule: (moduleId, jwtToken) =>
      dispatch(getsubModuleByModule(moduleId, jwtToken)),
    getBins: (jwtToken) => dispatch(getBins(jwtToken)),
    getUnmappedBins: (jwtToken) => dispatch(getUnmappedBins(jwtToken)),
    getActionsForMaping: (jwtToken) => dispatch(getActionsForMaping(jwtToken)),
    getUnmappedPallets: (jwtToken) => dispatch(getUnmappedPallets(jwtToken)),
    uploadAssetMaster: (payload, jwtToken) =>
      dispatch(uploadAssetMaster(payload, jwtToken)),
    getMappedBinsByRfid: (rfid, jwtToken) =>
      dispatch(getMappedBinsByRfid(rfid, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Action);
